export const testimonials = [
  {
    id: 1,
    name: 'Sarah M.',
    location: 'Philadelphia, PA',
    rating: 5,
    text: 'Team was professional, punctual, and friendly. My kitchen and bathroom are sparkling! The house smells fresh and clean without overpowering chemical scents. Highly recommend!',
    service: 'Deep Cleaning'
  },
  {
    id: 2,
    name: 'Jennifer K.',
    location: 'South Jersey',
    rating: 5,
    text: 'Priscilla and her team are amazing! Their attention to detail and flexibility means a lot to us. As a family with young children, we appreciate their responsiveness and consistent high-quality work.',
    service: 'Recurring Cleaning'
  },
  {
    id: 3,
    name: 'Michael R.',
    location: 'Bucks County, PA',
    rating: 5,
    text: 'The deep cleaning after we moved out was impressive and got the home ready for the next tenant. Floors shined after multiple passes with the mop. Bathrooms looked brand new!',
    service: 'Move In/Out Cleaning'
  },
  {
    id: 4,
    name: 'Real Estate Agent',
    location: 'Delaware County, PA',
    rating: 5,
    text: 'I highly commend Up Cleaning Pro for their prompt, attentive service. They helped prepare a large luxury home for settlement on short notice. Outstanding quality and professionalism!',
    service: 'Commercial Cleaning'
  },
  {
    id: 5,
    name: 'Patricia L.',
    location: 'Montgomery County, PA',
    rating: 5,
    text: 'Dependable and trustworthy! We have been using Up Cleaning for years. They are excellent in quality, responsive to our needs, and always deliver exceptional results.',
    service: 'Recurring Cleaning'
  },
  {
    id: 6,
    name: 'David T.',
    location: 'Atlantic City, NJ',
    rating: 5,
    text: 'The team cleaned every detail - baseboards, windowsills, kitchen appliances. Everything was spotless! They are meticulous and take pride in their work. Worth every penny!',
    service: 'Deep Cleaning'
  }
];

export const services = [
  {
    id: 1,
    title: 'Recurring Cleaning',
    description: 'Keep your home consistently fresh with our flexible weekly, bi-weekly, or monthly cleaning plans. Perfect for busy families and professionals.',
    features: ['Flexible scheduling', 'Same cleaner each visit', 'Customized cleaning plan', 'Eco-friendly products']
  },
  {
    id: 2,
    title: 'Deep Cleaning',
    description: 'A thorough top-to-bottom cleaning that tackles every nook and cranny. Perfect for spring cleaning or preparing for special occasions.',
    features: ['Detailed surface cleaning', 'Appliance cleaning', 'Baseboards & trim', 'Hard-to-reach areas']
  },
  {
    id: 3,
    title: 'Move In/Out Cleaning',
    description: 'Start fresh in your new home or ensure you get your deposit back. We make moving less stressful with our comprehensive cleaning service.',
    features: ['Inside cabinets & drawers', 'Deep bathroom cleaning', 'Kitchen appliances', 'Walls & baseboards']
  },
  {
    id: 4,
    title: 'Commercial Cleaning',
    description: 'Professional cleaning solutions for offices, retail spaces, and commercial properties. Keep your business looking its best.',
    features: ['After-hours service', 'Daily or weekly plans', 'Disinfection protocols', 'Professional equipment']
  },
  {
    id: 5,
    title: 'Post Construction Cleaning',
    description: 'Remove construction dust and debris to reveal your beautiful new space. We handle the tough post-renovation cleanup.',
    features: ['Dust removal', 'Window cleaning', 'Floor cleaning & polishing', 'Final touch details']
  },
  {
    id: 6,
    title: 'Vacation Rental Cleaning',
    description: 'Fast, reliable turnovers for your Airbnb or vacation rental. Keep your guests happy and your reviews glowing.',
    features: ['Quick turnaround', 'Linen service available', 'Restocking essentials', 'Quality inspections']
  }
];

export const stats = [
  { number: '747+', label: 'Happy Clients' },
  { number: '20,246+', label: 'Spaces Cleaned' },
  { number: '6+', label: 'Years Experience' },
  { number: '99%', label: 'Satisfaction Rate' }
];